import { Col, Layout, Pagination, Row, Typography } from "antd";

import { TfiComment } from "react-icons/tfi";

import { FaRegStar } from "react-icons/fa6";
import { BsFillStarFill } from "react-icons/bs";
import { FaStarHalfAlt } from "react-icons/fa";
import Comment from "../../components/comment";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Tabs } from "antd";
import { PiDotsThreeOutlineFill } from "react-icons/pi";

import { useSelector } from "react-redux";
import { Get } from "../../config/api/get";
import {
  COMMUNITY,
  UPLOADS_URL,
  UPLOAD_URL2,
} from "../../config/constants/api";
import swal from "sweetalert";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Delete } from "../../config/api/delete";
import { Post } from "../../config/api";
import { ImageUrl } from "../../helpers/Functions";
import "./community-post.css";

export default function CommunityPost() {
  const { _id } = useParams();
  const navigate = useNavigate();

  const [post, setPost] = useState({});
  const [, setLoading] = useState(true);
  const token = useSelector((state) => state.user.userToken);
  const [comment, setComment] = useState("");
  const [isHide, setIsHide] = useState(true);
  const [commentLoader, setCommentLoader] = useState(false);
  const loggedUserId = useSelector((state) => state.user.userData._id);

  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = post?.comments?.length
    ? `Showing ${endIndex} comments out of ${paginationConfig.totalDocs}`
    : "Showing comments 0 of 0";

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });
    getPosts(pageNumber, paginationConfig.limit);
  };
  async function getPosts(page, limit) {
    try {
      const response = await Get(COMMUNITY.getPost + "/" + _id, token, {
        page: page || paginationConfig.pageNumber,
        limit: limit || paginationConfig.limit,
      });
      if (response.status === true) {
        setLoading(false);
        setPost(response?.data);
        setPaginationConfig({
          ...paginationConfig,
          totalDocs: response?.data?.totalComments,
          totalPages: response?.data?.totalPages,
        });
      } else {
        swal("Error", "Something went wrong", "error");
      }
    } catch (error) {
      swal("Error", error?.message || "something went wrong", "error");
      console.log(error);
    }
  }
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="community-post-pagination-btn">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="community-post-pagination-btn">
          Next
        </button>
      );
    }
    return originalElement;
  };

  useEffect(() => {
    getPosts();
    // eslint-disable-next-line
  }, [_id]);


  const [selected, setSelected] = useState("post"); // mebmers profile
  const onChange = (key) => {
    setSelected(key);
  };

  const tabs = [
    {
      label: "Post",
      key: "post",
      children: "Post",
    },
    {
      label: "Members",
      key: "members",
      children: "Members",
    },
    {
      label: "Profile",
      key: "profile",
      children: "Profile",
    },
  ];

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update state when resizing
    };

    // Attach event listener to the window resize event
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener when the component is unmounted
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures it only runs once on mount

  function sendComment() {
    setCommentLoader(true);
    if (!comment) {
      swal("Oops!", "Please Enter Your Comment Before Submitting.", "error");
      setCommentLoader(false);

      return;
    }
    Post(`/community/${post?._id}/comment`, { text: comment }, token, null)
      .then((response) => {
        setCommentLoader(false);
        if (response?.data?.status) {
          swal("Success", "Comment added successfully", "success");
          setComment("");
          getPosts();
        } else {
          swal(
            "Oops!",
            response?.data?.message || response?.response?.data?.message,
            "error"
          );
          setCommentLoader(false);
        }
      })
      .catch((e) => {
        setCommentLoader(false);
        swal(
          "Error",
          "An error occurred while adding the comment to the post."
        );
      });
  }

  async function deletePost() {
    // alert("deleting" + "=>" + post._id)

    try {
      const response = await Delete(
        COMMUNITY.deletePost + "/" + _id,
        token,
        {}
      );
      if (response?.status === true) {
        navigate(-1);
        swal("Success", "Post deleted successfully", "success");
      } else {
        swal("Error", "Something went wrong", "error");
      }
    } catch (error) {
      swal("Error", error?.message || "something went wrong", "error");
      console.log(error);
    }
  }

  function updatePost() {
    navigate("/create-form", { state: { post } });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout className="community-post-page" style={{ minHeight: "100vh" }}>
      <Row className="blueBackground community-post-hero">
        <div className="community-post-hero-inner">
          <Typography.Text className="community-post-hero-kicker">
            Discussion
          </Typography.Text>
          <Typography.Title className="fontFamily1 community-post-hero-title" level={1}>
            Community
          </Typography.Title>
        </div>
      </Row>

      <Row className="community-post-tabs-row">
        <Tabs
          onChange={onChange}
          type="card"
          className="community-post-tabs-inner"
          items={tabs.map((tab, i) => {
            return {
              label: tab.label,
              key: tab.key,
              // children: `Content of Tab Pane ${tab.key}`,
            };
          })}
        />
      </Row>

      <Row className="community-post-layout" gutter={[20, 28]} justify="center">
        {/* List of User */}
        <Col
          xs={24}
          md={5}
          className={`${selected !== "members" && isMobile ? "hidden" : "userCol"}`}
        >
          <div className="community-post-members-shell">
            <p className="community-post-members-title">Community Members</p>

            <div className="community-post-members-scroll">
              <div className="community-post-members-list">
                {post?.members?.length > 0 ? (
                  post?.members.map((member, index) => (
                    <div key={index} className="community-post-member-row">
                      <img
                        src={
                          member.image
                            ? UPLOAD_URL2 + member.image
                            : ImageUrl("avatar.png")
                        }
                        alt="Member"
                        className="community-post-member-avatar"
                      />
                      <p className="community-post-member-name">
                        {member.firstName + " " + member.lastName}
                      </p>
                    </div>
                  ))
                ) : (
                  <p className="community-post-members-empty">No Members Found</p>
                )}
              </div>
            </div>
          </div>
        </Col>

        {/* Post Column */}

        <Col
          xs={24}
          md={14}
          className={`${selected !== "post" && isMobile ? "hidden" : "otherCol"}`}
        >
          <div className="community-post-main">
            <div className="community-post-article">
              {/* User profile */}
              <div className="community-post-author">
                <div className="community-post-author-main">
                  <img
                    src={
                      post?.user?.image
                        ? UPLOADS_URL + "/" + post.user.image
                        : ImageUrl("avatar.png")
                    }
                    alt="User"
                    className="community-post-author-avatar"
                  />
                  <div className="community-post-author-meta">
                    {post?.user?.firstName && (
                      <>
                        <p className="community-post-author-name">
                          {post?.user?.firstName + " " + post?.user?.lastName}
                        </p>
                        <p className="community-post-author-date">
                          {moment(post?.createdAt).format(
                            "MMMM Do YYYY, h:mm:ss a"
                          )}
                        </p>
                      </>
                    )}
                  </div>
                </div>

                <div
                  className={`${
                    loggedUserId !== post?.user?._id && "hidden"
                  } community-post-author-menu`}
                >
                  <PiDotsThreeOutlineFill
                    className="community-post-author-menu-trigger"
                    onClick={() => setIsHide(!isHide)}
                    size={24}
                  />

                  {!isHide && (
                    <div className="community-post-author-menu-dropdown">
                      <p
                        className="community-post-author-menu-item"
                        onClick={updatePost}
                      >
                        Update Post
                      </p>
                      <div className="community-post-author-menu-divider" />
                      <p
                        className="community-post-author-menu-item community-post-author-menu-item--danger"
                        onClick={() => {
                          swal({
                            title: "Are you sure?",
                            text: "Once deleted, you will not be able to recover this!",
                            icon: "warning",
                            buttons: {
                              cancel: "Cancel",
                              confirm: "Yes, delete it!",
                            },
                            dangerMode: true,
                          }).then((willDelete) => {
                            if (willDelete) deletePost();
                          });
                        }}
                      >
                        Delete Post
                      </p>
                    </div>
                  )}
                </div>
              </div>
              {/* Post details */}
              {Object.keys(post).length !== 0 ? (
                <div className="community-post-body-wrap">
                  <p className="community-post-body-title">{post.title}</p>
                  <div
                    className="community-post-body"
                    dangerouslySetInnerHTML={{ __html: post.description }}
                  />

                  {/* Post Image */}
                  {post?.thumbnail && (
                    <img
                      src={UPLOAD_URL2 + post.thumbnail}
                      alt="Post thumbnail"
                      className="community-post-feature-img"
                    />
                  )}
                </div>
              ) : (
                <div className="community-post-loading">
                  <div className="community-post-loading-spinner" aria-hidden="true" />
                  <span>Loading post...</span>
                </div>
              )}
            </div>
            {/* Post details */}

            {/*Add Comments */}
            <div className="community-post-comments">
              <p className="community-post-comments-heading">Comments</p>

              <div className="community-post-comment-composer">
                <input
                  onChange={(e) => setComment(e.target.value)}
                  value={comment}
                  type="text"
                  placeholder="Type here your wise comments"
                  className="community-post-comment-input"
                />
                <div>
                  <div className="community-post-comment-actions">
                    <button
                      type="button"
                      onClick={() => setComment("")}
                      className="community-post-btn-secondary"
                    >
                      delete
                    </button>

                    <button
                      type="button"
                      onClick={() => {
                        if (commentLoader) return;
                        sendComment();
                      }}
                      className="community-post-btn-primary"
                      disabled={commentLoader}
                    >
                      {commentLoader ? (
                        <span className="community-post-btn-spinner" aria-hidden="true" />
                      ) : (
                        <span className="community-post-btn-label">
                          <TfiComment aria-hidden="true" />
                          <span>Comment</span>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/*Add Comments */}

            {/* List of Comments whil will loop*/}
            <div className="community-post-comments-list">
              {post?.comments?.length > 0 ? (
                post?.comments.map((comments, index) => (
                  <Comment
                    Comment={comments}
                    postId={post?._id}
                    refetch={getPosts}
                    key={index}
                  />
                ))
              ) : (
                <p className="community-post-empty">No Comments Found</p>
              )}

              {post?.comments?.length > 0 && (
                <Row className="community-post-comments-pagination">
                  <Col xs={24}>
                    <div className="community-post-pagination-inner">
                      <p className="community-post-pagination-meta">{message}</p>
                      <Pagination
                        className="styledPagination community-post-pagination"
                        showSizeChanger={false}
                        onChange={(page) => handlePageChange(page)}
                        current={parseInt(paginationConfig.pageNumber, 10)}
                        pageSize={paginationConfig.limit}
                        total={paginationConfig.totalDocs}
                        itemRender={itemRender}
                      />
                    </div>
                  </Col>
                </Row>
              )}

              {/* {Array(3).fill(0).map((_, index) => (
              <Comment Comment={comments} key={index} />
            ))

            } */}
            </div>

            {/* List of Comments */}
          </div>
        </Col>

        {/* Profile Column */}
        <Col
          xs={24}
          md={5}
          className={`${selected !== "profile" && isMobile ? "hidden" : "otherCol"}`}
        >
          <div className="community-post-profile-wrap">
            <div className="community-post-profile-card">
              <img
                src={
                  post?.user?.image
                    ? `${UPLOADS_URL}/${post.user.image}`
                    : ImageUrl("avatar.png")
                }
                alt="Profile"
                className="community-post-profile-avatar"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = ImageUrl("avatar.png");
                }}
              />

              <div className="community-post-profile-meta">
                <p className="community-post-profile-name">
                  {post?.user && post.user.firstName + " " + post.user.lastName}
                </p>

                <div className="community-post-profile-stars">
                  <BsFillStarFill />
                  <FaStarHalfAlt />
                  <FaRegStar />
                  <FaRegStar />
                  <FaRegStar />
                </div>

                <p className="community-post-profile-reviews">0 Reviews</p>

                <div className="community-post-profile-rate">
                  Hourly Rates :{" "}
                  {post?.rates?.hourlyRate
                    ? `$ ${post?.rates?.hourlyRate}`
                    : " - "}
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}
